import fetch from "lib/fetch"
import { nonProdLogger } from "@theconversation/shared-libraries/nonProdLogger"

/*
  This is the "lightweight" implementation of the meta pixel tracker. Although facebook recommends
  using the "full" tracker (which involves downloading and executing third party scripts), this
  lightweight implementation meets all our current needs, is less invasive, and has a smaller footprint.

  https://developers.facebook.com/docs/meta-pixel/advanced#installing-the-pixel-using-an-img-tag
*/
export const createEventEmitter = (pixelId) => ({
  emit: (eventName, parameters = {}) => {
    const customParameters = Object.keys(parameters).reduce(
      (s, key) => s + `&cd[${key}]=${encodeURIComponent(parameters[key])}`,
      "",
    )
    fetch(`https://www.facebook.com/tr?id=${pixelId}&ev=${eventName}${customParameters}`)
  },
})

export default function emitMetaPixelEventsForContentRead(contentId, contentTitle) {
  const config = window.META_PIXEL_CONFIG
  if (!config || !config.id || !contentId) return

  // content.js calls this before awaiting its own promos rendering, so an error here shouldn't
  // be allowed to take that down too.
  try {
    const emitter = createEventEmitter(config.id)

    // We're only ever called from content.js (Content#show), so content_type is hardcoded to
    // "content" here rather than accepted as a parameter.
    emitter.emit("ViewContent", {
      content_name: contentTitle,
      content_type: "content",
      content_ids: contentId,
    })

    // After 15 seconds we emit a `AddToCard` event, this was changed from
    // the previous `TimeOnPage` and `Lead` event, as Benedictus (the ad agency) was having
    // trouble integrating it into their system (despite originally asking for it).
    setTimeout(() => emitter.emit("AddToCart"), 15000)
  } catch (err) {
    nonProdLogger(`Error emitting Meta Pixel events: ${err.message}`)
  }
}
